/*
* Salla Login Component: login popup modal
* You can use these classes to target the elements in the component.
*/

.s-login-modal {
  &-sub-title {

  }
  &-main-btn {
    
  }
  &-main-btn-icon {

  }
  &-main-btn-text {

  }
  &-main-btn-arrow {

  }
  &-label {

  }
  &-input {

  }
  &-otp-input {

  }
  &-link {

  }
  &-error-message {

  }
  &-wrapper {

  }
  &-tab {

  }
  &-active {

  }
  &-unactive {

  }
}
